import React, {useImperativeHandle, forwardRef} from 'react'
import PropTypes from 'prop-types'
import {Stack, Box, Flex} from '@salesforce/retail-react-app/app/components/shared/ui'
import {FormattedMessage} from 'react-intl'
import {useForm} from 'react-hook-form'
import Field from '../../field'
import useGiftCardFields from '../../forms/useGiftCardFields'

const GiftCardForm = forwardRef(({isVisible = false, headingIndex = 4}, ref) => {
    const form = useForm({
        defaultValues: {
            yourName: '',
            recipientName: '',
            recipientEmail: '',
            confirmRecipientEmail: '',
            message: ''
        }
    })

    const fields = useGiftCardFields({
        form,
        prefix: ''
    })

    // Expose validation functions to parent
    useImperativeHandle(
        ref,
        () => ({
            validate: async () => {
                const result = await form.trigger()
                return result
            },
            getFormState: () => form.formState,
            getValues: () => form.getValues(),
            isValid: () => form.formState.isValid,
            reset: () => form.reset()
        }),
        [form]
    )

    if (!isVisible) {
        return null
    }

    return (
        <Box>
            <Box marginBottom={3} fontSize="sm" fontWeight="bold">
                <FormattedMessage
                    id="gift_card_form.heading.who_is_this_for"
                    defaultMessage="{headingIndex}. Who is this for?"
                    values={{headingIndex}}
                />
            </Box>
            <Stack spacing={4} align="stretch">
                <Flex direction={{base: 'column', lg: 'row'}} gap={{base: 4, lg: 6}}>
                    <Box flex="1">
                        <Field {...fields.yourName} />
                    </Box>
                    <Box flex="1">
                        <Field {...fields.recipientName} />
                    </Box>
                </Flex>

                <Flex direction={{base: 'column', lg: 'row'}} gap={{base: 4, lg: 6}}>
                    <Box flex="1">
                        <Field {...fields.recipientEmail} />
                    </Box>
                    <Box flex="1">
                        <Field {...fields.confirmRecipientEmail} />
                    </Box>
                </Flex>

                <Field {...fields.message} />
            </Stack>
        </Box>
    )
})

GiftCardForm.displayName = 'GiftCardForm'

GiftCardForm.propTypes = {
    isVisible: PropTypes.bool,
    headingIndex: PropTypes.number
}

export default GiftCardForm
